import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { View, Paragraph } from '@uncinc/react-drupal-core';

import { PageHeader, Breadcrumbs, WysiwygField } from '../../../../components';

import './style.scss';

const TaxonomyTermThemeFull = (props) => {
  const { entity, className } = props;
  const classes = classNames(className, 'Theme', 'TaxonomyTerm', 'TaxonomyTermThemeFull');

  const tid = entity.getIn(['tid', 0, 'value'], '');
  const title = entity.getIn(['name', 0, 'value'], '');
  const body = entity.getIn(['description', 0, 'processed'], '');

  const [filters, setFilters] = useState({
    field_theme_target_id: [tid],
    type: [],
  });

  const list = {
    artikelen: {
      type: ['article'],
      title: 'Artikelen',
    },
    nieuws: {
      type: ['news'],
      title: 'Nieuws',
    },
    downloads: {
      type: ['download'],
      title: 'Downloads',
    },
    opinies: {
      type: ['opinion', 'interview'],
      title: 'Opinie & Interviews',
    },
  };

  const toggleFilter = (id) => {
    if (filters.type.indexOf(id) === 0) {
      setFilters({
        field_theme_target_id: [tid],
        type: [],
      });
    } else {
      setFilters({
        field_theme_target_id: [tid],
        type: id,
      });
    }
  };

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      field_theme_target_id: [tid],
    }));
  }, [tid]);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <PageHeader>
        <Breadcrumbs includeCurrent />
        <h1 className="PageHeader__title">{title}</h1>
        <WysiwygField
          property="schema:text"
          className="body-intro"
          html={body}
        />
        <div className="TaxonomyTermThemeFull__filters">
          <View id="themes" display="select" entity={entity} />
          <div className="input__tags">
            <div className="label">Filter op type:</div>
            <div className="Filter__tags">
              <ul className="tags">
                {Object.keys(list).map((value, index) => {
                  const classes = classNames('', {
                    selected: list[value].type.some((t) => filters.type.includes(t)),
                  });

                  return (
                    <li key={`list:${index}`} onClick={() => toggleFilter(list[value].type)} className={classes}>{list[value].title}</li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </PageHeader>
      <div className="TaxonomyTermThemeFull__contentWrapper" />
      <View id="grouped_content" display="theme_detail_promoted" filters={filters} />
      <View id="grouped_content" display="theme_detail" filters={filters} />

      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}

      <View id="grouped_content" display="theme_detail_more" filters={filters} />
    </article>
  );
};

export default TaxonomyTermThemeFull;
